module.exports = __webpack_public_path__ + "img/rs.rsfeac461.svg";